import React from 'react';
import Stack from '../../v2BaseComponents/Stack';
import useOrganizationClientRecordBillingDetails from '../../../hooks/api/useOrganizationClientRecordBillingDetails';
import { getIntl } from '../../../utils/intl';
import Text from '../../v2BaseComponents/Text';
import SkeletonLoadingContainer from '../../v2BaseComponents/SkeletonLoadingContainer';
import Link from '../../v2BaseComponents/Link';

const intl = getIntl('billingContactDetailsHeader', {
    headerPreText: 'Billing Contact: ',
    edit: 'Edit',
});

export type BillingContactDetailsHeaderOwnProps = {
    onEdit: () => void;
    clientRecordId: string;
};

export type BillingContactDetailsHeaderProps = BillingContactDetailsHeaderOwnProps;

const messagePlaceholder = 'Billing Contact (billingContact@gmail.com)';

const BillingContactDetailsHeader: React.FC<BillingContactDetailsHeaderProps> = ({ clientRecordId, onEdit }) => {
    const { isLoadingBillingDetails, billingDetails } = useOrganizationClientRecordBillingDetails({
        organizationClientRecordId: clientRecordId,
    });

    const getBillingContactText = () => {
        if (isLoadingBillingDetails) {
            return messagePlaceholder;
        } else if (billingDetails) {
            return `${billingDetails.name} (${billingDetails.email})`;
        } else {
            return '';
        }
    };

    return (
        <Stack vertical fullWidth align="flex-start" testID="billing-contact-details-header">
            <SkeletonLoadingContainer isLoading={isLoadingBillingDetails}>
                <Text variant="body-1">
                    <Text variant="bold-body-1">{intl('headerPreText')}</Text>
                    <Text variant="body-1" wrapText>
                        {getBillingContactText()}
                    </Text>
                </Text>
            </SkeletonLoadingContainer>
            <Link
                variant="body-1"
                onPress={onEdit}
                isDisabled={isLoadingBillingDetails}
                testID="client-details-header-edit"
            >
                {intl('edit')}
            </Link>
        </Stack>
    );
};

export default React.memo(BillingContactDetailsHeader);
